import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Persistent (non-dismissible) banner for members whose Verified ID badge was reset in the
// platform-wide re-verification. It stays until they re-verify. The CTA routes to /verify, which
// launches the Stripe flow immediately. Listings stay live — this only blocks NEW listings.
export default function ReverifyBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const needs = !!(user && user.reverify_required && !user.identity_verified);

  if (!needs) return null;
  return (
    <div
      role="status"
      data-testid="reverify-banner"
      className="w-full bg-volt/15 border-b border-volt/40 text-foreground px-4 py-2.5 flex flex-col sm:flex-row items-center justify-center gap-x-3 gap-y-1.5 text-center"
    >
      <span className="inline-flex items-center gap-2 font-mono text-xs sm:text-sm leading-tight">
        <ShieldAlert className="w-4 h-4 text-volt shrink-0" />
        We've reset every beta tester's Verified ID badge for a platform-wide re-check — routine, not a flag on your account. Your listings stay live; re-verify to post new ones.
      </span>
      <button
        onClick={() => navigate("/verify")}
        data-testid="reverify-banner-cta"
        className="shrink-0 bg-volt text-black font-heading font-bold uppercase text-xs px-4 py-1.5 hover:bg-volt/90 transition-colors"
      >
        Re-verify my ID
      </button>
    </div>
  );
}
